<au-impersonation-banner></au-impersonation-banner>
<div class="main-body">
  <div class="main-header grid m-0">
    <div class="hidden-mobile col-2 pl-3"></div>
    <div class="col-12 lg:col-7">
      <img
        [src]="mercuryLogoPath"
        class="landing-mercury-logo"
        alt="Mercury Logo"
      />
      <p class="description page-title-medium color-base-white-white-100">
        {{ title }}
      </p>
    </div>
    <div class="hidden-mobile col-3 header-art" style="display: block">
      <img
        style="height: 140px"
        [src]="isometricGridPath"
        class="isometric-grid"
        alt="Isometric Grid"
      />
    </div>
  </div>
  <div class="main-content grid m-0 p-0">
    <div class="col-0 md:col-6 lg:col-2"></div>
    <div class="col-12 lg:col-8">
      <router-outlet></router-outlet>
    </div>
    <div class="col-0 md:col-6 lg:col-2"></div>
  </div>
</div>
